/* CollaPure Landingpage — Verhalten 1:1 aus HOMEPAGE/index-v2.html.
   Lädt als ES-Modul (dedupliziert), re-initialisiert bei Theme-Editor-Events. */

document.documentElement.classList.add('cp-js');

const EASE_IO_OPTS = { threshold: 0.14, rootMargin: '0px 0px -40px 0px' };

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('cp-in');
      revealObserver.unobserve(entry.target);
    }
  });
}, EASE_IO_OPTS);

const barsObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('.cp-abar span').forEach((bar) => {
      bar.style.width = (bar.dataset.w || 0) + '%';
    });
    barsObserver.unobserve(entry.target);
  });
}, { threshold: 0.3 });

function initScope(scope) {
  scope.querySelectorAll('.cp-reveal:not(.cp-in)').forEach((el) => revealObserver.observe(el));
  scope.querySelectorAll('.cp-kda-wrap').forEach((el) => barsObserver.observe(el));

  /* ===== Nav: Scroll-State + Mobile-Menü + Sprache ===== */
  scope.querySelectorAll('.cp-nav:not([data-cp-init])').forEach((nav) => {
    nav.dataset.cpInit = '1';
    const onScroll = () => nav.classList.toggle('cp-scrolled', window.scrollY > 20);
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const root = nav.closest('.cp-header-root') || document;
    const menu = root.querySelector('.cp-mobile-menu');
    const burger = nav.querySelector('.cp-burger');
    if (menu && burger) {
      burger.addEventListener('click', () => menu.classList.add('cp-open'));
      menu.querySelectorAll('a, .cp-mm-close').forEach((el) =>
        el.addEventListener('click', () => menu.classList.remove('cp-open'))
      );
    }

    nav.querySelectorAll('.cp-lang button[data-locale]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const form = btn.closest('form');
        if (!form) return;
        form.querySelector('[data-cp-localization-input]').value = btn.dataset.locale;
        form.submit();
      });
    });
  });

  /* ===== Siegel-Code-Prüfung ===== */
  scope.querySelectorAll('.cp-qs-lookup:not([data-cp-init])').forEach((lookup) => {
    lookup.dataset.cpInit = '1';
    const input = lookup.querySelector('input');
    const button = lookup.querySelector('button');
    const result = lookup.querySelector('.cp-qs-result');
    if (!input || !button || !result) return;

    const prefix = (lookup.dataset.prefix || 'CP').toUpperCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp('^' + prefix + '[- ]?\\w{3,}$');

    const check = () => {
      const value = input.value.trim().toUpperCase();
      if (!value) {
        result.className = 'cp-qs-result cp-no';
        result.textContent = lookup.dataset.msgEmpty || '';
        return;
      }
      if (lookup.dataset.mode === 'pending') {
        result.className = 'cp-qs-result cp-neutral';
        result.textContent = lookup.dataset.msgPending || '';
        return;
      }
      const ok = pattern.test(value);
      result.className = 'cp-qs-result ' + (ok ? 'cp-ok' : 'cp-no');
      result.textContent = ok ? (lookup.dataset.msgOk || '') : (lookup.dataset.msgNo || '');
    };

    button.addEventListener('click', check);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        check();
      }
    });
  });
}

initScope(document);

/* Theme-Editor: neu geladene/umsortierte Sections erneut initialisieren */
document.addEventListener('shopify:section:load', (e) => initScope(e.target));
document.addEventListener('shopify:section:select', (e) => {
  e.target.querySelectorAll('.cp-reveal:not(.cp-in)').forEach((el) => el.classList.add('cp-in'));
});
